export const comprometimentoStatus = {
    EM_VERIFICACAO: -1,
    EM_ABERTO: 0,
    EM_ANALISE: 1,
    APROVADA: 2,
    REPROVADA: 3
}
